
const Loading = () => (
    <div id="loading">
        <div class="three-body">
            <div className="three-body__dot"></div>
            <div className="three-body__dot"></div>
            <div className="three-body__dot"></div>
        </div>
    </div>
) 


export default Loading;